import { axios } from "helper/axios";
import { jarvisPrimeInvestMoreConstants } from "./jarvisPrimeInvestMoreConstants";

const jarvisPrimeInvestMoreApis = {};

jarvisPrimeInvestMoreApis.getInvestmentPricingDetails = ({ investmentAmount }) => {
    return axios.post(jarvisPrimeInvestMoreConstants.PRIME_INVESTMENT_PRICING_DETAILS_API, {
        investmentAmount,
    });
};

jarvisPrimeInvestMoreApis.submitInvestMore = ({ investmentAmount }) => {
    return axios.post(jarvisPrimeInvestMoreConstants.SUBMIT_PRIME_INVEST_MORE_API, {
        investmentAmount,
    });
};

jarvisPrimeInvestMoreApis.getInvestmentStocks = () => {
    return axios.get(jarvisPrimeInvestMoreConstants.PRIME_INVESTMENT_STOCKS_API);
};

export { jarvisPrimeInvestMoreApis };
